import React from "react";
import { Link } from "react-router-dom";
import TooltipComponent from "../reusables/TooltipComponent";
import RouteSelect from "../reusables/RouteSelect";
import { Divider } from "@mui/material";

/**
 * Pure UI component for ElevenLabs action
 * All logic is handled by useElevenLabsAction hook
 */
const ElevenLabsUI = ({
  agentIdValue,
  handleAgentIdChange,
  imgError,
  setImgError,
  containerClass,
  inputClass,
  headerSize,
  showDivider,
  useIVRStyle,
  setOpenConfigureSlotModal,
  hasValidationError = false,
  agentOptions = [],
  hasElevenLabsAgents = false,
}) => {
  // Always use the same icon/fallback regardless of context
  // useIVRStyle only affects layout/styling, not the icon
  const title = "Eleven Labs (beta)";
  const subtitle = "Forward to Eleven Labs Voice Agent";

  return (
    <div>
      <div className={`${containerClass}${hasValidationError ? " !bg-red-50/80" : ""}`}>
        {/* Header */}
        <div className="flex flex-nowrap items-center justify-between gap-3 mb-5">
          <div className="flex items-center min-w-0 flex-1">
            {imgError ? (
              <div className="w-5 h-5 shrink-0 bg-indigo-500 rounded flex items-center justify-center text-white text-xs font-bold">
                11
              </div>
            ) : (
              <img
                src="/icons/elevenlabs.svg"
                alt="Eleven Labs"
                className="w-5 h-5 shrink-0"
                onError={() => setImgError(true)}
              />
            )}
            <div className="min-w-0 ml-2">
              <h2 className={`${headerSize} text-gray-800`}>
                {title}
              </h2>
              <div className="text-[13px]">{subtitle}</div>
            </div>
          </div>
          {setOpenConfigureSlotModal && (
            <button
              className="shrink-0 whitespace-nowrap text-sm text-blue-600 font-medium hover:underline text-[13px]"
              onClick={() => setOpenConfigureSlotModal(true)}
            >
              ↻ Change
            </button>
          )}
        </div>
        {showDivider && <Divider />}

        {/* Agent */}
        <div>
          <div className="flex items-center gap-1 mb-1">
            <span className="text-sm font-medium text-gray-700">
              Eleven Labs Agent
            </span>
            {!useIVRStyle && (
              <TooltipComponent message={"Select the Voice Agent to forward this call to Eleven Labs"} />
            )}
          </div>
          <RouteSelect
            value={agentIdValue || ""}
            onChange={handleAgentIdChange}
            options={agentOptions}
            placeholder="Select agent..."
          />
          <div className="mt-2 text-[13px]">
            {hasElevenLabsAgents ? (
              <Link
                to="/dashboard/channels"
                className="text-blue-600 hover:underline font-medium"
              >
                Manage or refresh agents in Channels →
              </Link>
            ) : (
              <div className="text-gray-600">
                <span className="font-medium">Setup required:</span> Add an ElevenLabs channel in{" "}
                <Link to="/dashboard/channels" className="text-blue-600 hover:underline font-medium">
                  Channels
                </Link>{" "}
                to configure and enable agents for this route.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ElevenLabsUI;
